import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from '@ipc/ipc-core';
import '../../applicationMenu.scss';

export class ApplicationAccessMenu extends Component {
  render() {
    const {
      name,
      type,
      imgSrc,
    } = this.props;

    const wizardUrl = '/dashboard';

    return (
      <Link to={wizardUrl} key={type} onClick={this.props.getSelectedAssetType}>
        <div className="asset-types__type">
          <h5 className="asset-type-name">
            {name}
          </h5>
          <img src={imgSrc} alt={name} width="196" height="196" />
        </div>
      </Link>
    );
  }
}

ApplicationAccessMenu.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  imgSrc: PropTypes.string,
  getSelectedAssetType: PropTypes.func,
};

export default ApplicationAccessMenu;
